import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/swiper-bundle.css";
import { useNavigate } from "react-router-dom";
SwiperCore.use([Navigation, Pagination]);

const TileSelection = ({ setSelectedTile }) => {
  const [tiles, setTiles] = useState([]);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const baseUrl = "https://d3ejxze7429gw1.cloudfront.net";
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const updateMedia = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  useEffect(() => {
    async function fetchTiles() {
      try {
        const response = await fetch(`${baseUrl}/products`);
        const data = await response.json();

        // Exclude category "Sanittary Ware"
        const filteredData = data.filter(
          (product) => product.category !== "Sanittary Ware"
        );

        // Map to internal tile structure
        const mapped = filteredData.map((product) => ({
          id: product.id,
          name: product.title,
          price: product.price,
          size: product.specifications?.size || "N/A",
          category: product.category,
          image: product.imageUrl,
        }));

        setTiles(mapped);

        const uniqueCategories = [
          "All",
          ...new Set(mapped.map((t) => t.category)),
        ];
        setCategories(uniqueCategories);
      } catch (err) {
        console.error("Error fetching tiles:", err);
      }
    }

    fetchTiles();
  }, []);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };
  const getFullImageUrl = (path) => {
    if (!path) return ""; // or a fallback image path like "/images/default-tile.jpg"
    return path.startsWith("http") ? path : `${baseUrl}${path}`;
  };

  const filteredTiles =
    selectedCategory === "All"
      ? tiles
      : tiles.filter((tile) => tile.category === selectedCategory);

  return (
    <div className="tile-selection">
      <h2>Select your tile:</h2>

      <div className="category-filter">
        <label htmlFor="category">Filter by Category:</label>
        <select
          id="category"
          value={selectedCategory}
          onChange={handleCategoryChange}
        >
          {categories.map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>

      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        navigation={isDesktop}
        loop={true}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 30 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
      >
        {filteredTiles.length > 0 ? (
          filteredTiles.map((tile) => (
            <SwiperSlide key={tile.id}>
              <div className="tile-card">
                <img
                  src={getFullImageUrl(tile.image)}
                  alt={tile.name}
                  className="tile-image"
                />
                <div className="tile-details">
                  <h3>{tile.name}</h3>
                  <p className="tile-price">Price: €{tile.price}</p>
                  <p className="tile-size">Size: {tile.size}</p>
                  <button
                    onClick={() => navigate(`/pre-order/${tile.id}`)}
                    className="select-button"
                  >
                    Select
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide>
            <p className="loading-message">Loading tiles...</p>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
};

export default TileSelection;
